import { Link } from "react-router-dom";
import type { Film } from "@/mocks/films";
import { getCategoryName } from "@/mocks/films";

interface FilmListRowProps {
  film: Film;
  index: number;
}

export default function FilmListRow({ film, index }: FilmListRowProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
    >
      <div className="w-20 sm:w-24 shrink-0 aspect-[3/4] rounded-md overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title} 影片海报`}
          title={`${film.title} · 欧美成人电影`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start gap-2">
          <span className="mt-0.5 text-[11px] text-foreground-400 font-mono shrink-0">
            {String(index + 1).padStart(2, "0")}
          </span>
          <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-accent-700 transition-colors line-clamp-1">
            {film.title}
          </h3>
          <span className="ml-auto shrink-0 flex items-center gap-1 text-xs font-semibold text-accent-700">
            <i className="ri-star-fill text-[10px]" />
            {film.rating.toFixed(1)}
          </span>
        </div>
        <p className="mt-1 text-xs text-foreground-500">
          {film.year} · {film.region} · {film.duration} 分钟 · 导演 {film.director}
        </p>
        <p className="mt-2 text-[13px] leading-relaxed text-foreground-600 line-clamp-2">
          {film.summary}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          {film.categories.map((slug) => (
            <span
              key={slug}
              className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-800"
            >
              {getCategoryName(slug)}
            </span>
          ))}
          <span className="text-[11px] text-foreground-400 hidden sm:inline truncate">
            主演 {film.cast.join(" / ")}
          </span>
        </div>
      </div>
    </Link>
  );
}